import { instanceEmployee } from '../../../../services/instances';

export const getSubcompany = async (): Promise<any> => {
    const response = await instanceEmployee.get<any>('/sub_company');
    return response.data.data;
};
